import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { apiFetch } from '../../utils/api'
import styles from './VerifyPage.module.css'

interface VerifyResult {
  valid: boolean
  employeeName?: string
  periodLabel?: string
  companyName?: string
  generatedAt?: string
  verifiedCount?: number
}

export function VerifyPage() {
  const { token } = useParams<{ token: string }>()
  const { t } = useTranslation()
  const [result, setResult] = useState<VerifyResult | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!token) {
      setResult({ valid: false })
      setLoading(false)
      return
    }

    apiFetch<VerifyResult>(`/verify/${token}`)
      .then(res => {
        setResult(res.data ?? { valid: false })
      })
      .finally(() => setLoading(false))
  }, [token])

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <p>{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>MIREY</div>

        {result?.valid ? (
          <>
            <div className={styles.badge + ' ' + styles.badgeValid}>
              {t('verify.valid')}
            </div>
            <div className={styles.details}>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>{t('verify.employee')}</span>
                <span className={styles.detailValue}>{result.employeeName}</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>{t('verify.period')}</span>
                <span className={styles.detailValue}>{result.periodLabel}</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>{t('verify.company')}</span>
                <span className={styles.detailValue}>{result.companyName}</span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>{t('verify.generated')}</span>
                <span className={styles.detailValue}>{result.generatedAt}</span>
              </div>
            </div>
            <p className={styles.verifyCount}>
              {t('verify.verified_count', { count: result.verifiedCount })}
            </p>
          </>
        ) : (
          <>
            <div className={styles.badge + ' ' + styles.badgeInvalid}>
              {t('verify.invalid')}
            </div>
            <p className={styles.invalidText}>{t('verify.invalid_text')}</p>
          </>
        )}
      </div>
    </div>
  )
}
